"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var TopBar = function TopBar(_ref) {
  var sticky = _ref.sticky,
      stickyXS = _ref.stickyXS,
      stickySM = _ref.stickySM,
      stickyMD = _ref.stickyMD,
      stickyLG = _ref.stickyLG,
      className = _ref.className,
      children = _ref.children,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? "4" : _ref$spacing;
  var cname = 'TopBar';

  if (sticky) {
    cname += ' TopBarSticky';
  }

  if (stickyXS) {
    cname += ' TopBarSticky-xs';
  }

  if (stickySM) {
    cname += ' TopBarSticky-sm';
  }

  if (stickyMD) {
    cname += ' TopBarSticky-md';
  }

  if (stickyLG) {
    cname += ' TopBarSticky-lg';
  }

  if (className) {
    cname += " ".concat(className);
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: cname
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    span: "12",
    spacing: spacing
  }, children));
};

exports.TopBar = TopBar;